/** API host — see .env (REACT_APP_API_LOCAL_URL or REACT_APP_API_URL) */

const DEFAULT_API = 'http://13.126.29.66:5000';

function resolveApiHost(): string {
  const fromEnv =
    process.env.REACT_APP_API_LOCAL_URL ?? process.env.REACT_APP_API_URL;
  if (fromEnv === '') return '';
  if (fromEnv) return fromEnv.replace(/\/$/, '');
  return DEFAULT_API;
}

export const API_LOCAL_HOST = resolveApiHost();

/** @deprecated Use API_LOCAL_HOST — kept for older imports */
export const API_PROD_HOST = API_LOCAL_HOST;

const API_BASE_PATH = process.env.REACT_APP_API_BASE_PATH || '';

export function buildApiBaseUrl(host: string): string {
  const apiBase = host.replace(/\/$/, '');
  if (!API_BASE_PATH) return apiBase;
  const path = API_BASE_PATH.startsWith('/') ? API_BASE_PATH : `/${API_BASE_PATH}`;
  return `${apiBase}${path}`;
}

export function getActiveApiHost(): string {
  return API_LOCAL_HOST;
}

export function getActiveApiBaseUrl(): string {
  return buildApiBaseUrl(getActiveApiHost());
}

export function isLocalApi(): boolean {
  return true;
}
